import styled, { css, keyframes } from 'styled-components';

export const RED = '#DB2828';
export const GREEN = '#21BA45';
export const BLUE = '#0095E8';
export const WHITE = '#ffffff';
export const YELLOW = '#FBCC08';
export const BLACK = '#383737';
export const GRAY = 'rgba(255,255,255,.2)';
export const LIGHT_GRAY = '#eeeeee';

export const getColor = (messageType) => {
  if (messageType === 'error') return { bgColor: RED, color: '#fff' };
  if (messageType === 'log') return { bgColor: GREEN, color: '#fff' };
  return { bgColor: '#e7e7e7', color: '#000' };
};

export const Blur = styled.div`
  ${({ position }) => css`
    position: absolute;
    left: 0;
    ${position === 'top' &&
    css`
      top: 0;
      box-shadow: 0px 2px 8px rgba(56, 55, 55, 0.5);
    `};
    ${position === 'bottom' &&
    css`
      bottom: 0;
      box-shadow: 0px -2px 8px rgba(56, 55, 55, 0.5);
    `};
    min-width: 100vw;
    /* width: 100%; */
    padding: 0.9rem;
    background-color: rgba(56, 55, 55, 0.5);
    -webkit-backdrop-filter: blur(4px);
    -o-backdrop-filter: blur(4px);
    -moz-backdrop-filter: blur(4px);
    backdrop-filter: blur(4px);
  `}
`;

export const TimeStamp = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 1.5em;
  ${({ bgColor, color }) => css`
    border-radius: 8px;
    color: ${color};
    background-color: ${bgColor};
  `}
`;

export const Label = styled.div`
  display: flex;
  border-radius: 8px;
  box-sizing: border-box;
  background-color: #666;
  color: #eee;
  padding: 0px;
  margin: 0px;
  > div {
    padding: 0px 5px;
    height: auto;
  }
  > div:first-child {
    display: flex;
    align-items: center;
    background-color: #eee;
    color: #666;
    margin: 0px;
    padding: 2px 5px;
    border-top-left-radius: 8px;
    border-bottom-left-radius: 8px;
  }
`;

export const Message = styled.div``;

export const SettingsWrapper = styled.div``;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  height: 100%;
  min-width: 100%;
  margin: 0px;
  padding: 15px 0px 10px;
  overflow-y: scroll;
  overflow-x: hidden;
`;

const blinker = (flashColor) => keyframes`
  50% {
    background-color: ${flashColor};
  }
`;

export const getBlinkingText = (blink, flashColor) => {
  if (blink) {
    return css`
      animation: ${blinker(flashColor)} 0.5s linear 0ms;
      -webkit-animation: ${blinker(flashColor)} 0.5s linear 0ms;
    `;
  }
  return null;
};

export const Row = styled.div`
  display: grid;
  grid-template-columns: max-content auto max-content max-content max-content;
  align-items: center;
  width: 100%;
  box-sizing: border-box;
  border-radius: 10px;
  ${({ latestMessage, flashColor }) =>
    getBlinkingText(latestMessage, flashColor)}
  && ${TimeStamp} {
    padding: 5px 20px;
  }
`;

export const TopContainer = styled.div`
  display: flex;
  align-items: center;
  position: absolute;
  z-index: 2;
  top: -35px;
  left: 10px;
  width: 95vw;
  margin-top: 25px;
  font-weight: bold;
  font-size: clamp(0.8rem, 1.1vw, 1.3rem);
`;

export const MessageWrapper = styled.div`
  display: flex;
  align-items: center;
  background-color: ${({ bgColor }) => bgColor || '#383737'};
  color: ${({ color }) => color || '#fff'} !important;
  ${({ highlight, highlightColor }) =>
    highlight &&
    css`
      background-color: ${highlightColor};
      & label {
        color: ${WHITE} !important;
      }
      border-radius: 8px;
      height: 1.5rem;
    `}
  border-radius: 10px;
  border: 2px solid #666;
  box-sizing: border-box;
  height: 50px;
  padding: 5px 15px;
  i {
    margin-right: 5px;
  }
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px;
  ${({ highlight, highlightColor }) =>
    highlight &&
    css`
      background-color: ${highlightColor};
      & label {
        color: ${WHITE} !important;
      }
      border-radius: 8px;
      height: 1.2rem;
    `}
`;

export const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  box-sizing: border-box;
  padding: 0px;
  && ${MessageWrapper} {
    margin-left: 0px;
    margin-right: 0px;
  }
`;

// export const MessageCount = styled.div`
//   margin: 0px 10px;
//   min-width: 75px;
//   ${({ color }) => color && `color: ${color}`};
//   ::before {
//     content: ' / ';
//     color: #fff;
//   }
// `;

export const CloseContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: -35px;
  right: 30px;
  margin-top: 25px;
  background-color: #383737;
  border-radius: 50%;
  border: 2px solid #666;
  box-sizing: border-box;
  height: 50px;
  width: 50px;
  z-index: 2000;
  :hover {
    cursor: pointer;
  }
  & i {
    color: #ccc;
    font-size: clamp(1.2rem, 1.8vw, 2rem);
    transform: rotate(0deg);
    transition: transform 0.3s ease-in-out;
    :hover {
      transform: rotate(90deg);
      color: #fff;
    }
  }
`;

export const ResizeContainer = styled(CloseContainer)`
  right: 85px;
  z-index: 1000;
`;

export const Container = styled.div`
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  gap: 0px;
  min-width: 100%;
  height: ${({ fullscreen }) => (fullscreen ? 'calc(100vh - 50px)' : '50vh')};
  padding: 10px 25px 10px 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10000;
  background: #383737;
  color: #eee;
  font-family: 'Courier New', monospace;
  font-size: clamp(0.7rem, 0.9vw, 1rem);
  box-shadow: 0 -15px 10px -5px rgba(0, 0, 0, 0.3);
  margin-left: -10px;

  & i,
  label,
  strong {
    color: #eee;
  }
  & div {
    color: #eee;
    margin: 10px 5px;
    & button {
      height: 50px;
      width: 100%;
      font-size: 1em;
    }
  }
  && ${Row} {
    height: max-content;
    padding: 0px;
    margin: 0px;
    border-bottom: 1px solid #eee;
    text-align: left;
  }
`;

export const FilterWrapper = styled.div`
  height: 20px;
  display: flex;
  align-items: center;
  padding: 4px;
  border: 1px solid #eee;
  border-radius: 4px;
  > input,
  label {
    margin: 0px 2px;
  }
`;

export const Badge = styled.div`
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  font-weight: 900;
  box-sizing: border-box;
  ${({ color, bgColor }) => css`
    background-color: ${bgColor};
    color: ${color} !important;
  `}import { Label } from '../StartingBidAmount/Styles';

`;

export const MessageCount = styled(Badge)`
  height: 35px;
  width: 35px;
  font-weight: 600;
  font-size: 0.8em;
`;
